(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-bottom-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mobile-bottom-navigation')) {
    customElements.define('mobile-bottom-navigation', class MobileBottomNavigation extends HTMLElement {
      connectedCallback() {
        this.style.setProperty('--mobile-nav-items', this.querySelectorAll('[data-mobile-nav-action]').length || 1);
        this.addEventListener('click', this.handleClick);
        this.headerBadge = document.querySelector('header-component [data-cart-badge]');
        this.syncCartCount();

        if (this.headerBadge) {
          this.cartObserver = new MutationObserver(() => this.syncCartCount());
          this.cartObserver.observe(this.headerBadge, { childList: true, characterData: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        if (this.cartObserver) this.cartObserver.disconnect();
      }

      handleClick = (event) => {
        const item = event.target.closest('[data-mobile-nav-action]');
        if (!item) return;

        const action = item.dataset.mobileNavAction;
        const selector = action === 'search'
          ? 'header-component [data-search-toggle]'
          : action === 'cart'
            ? 'header-component [data-cart-drawer-toggle]'
            : action === 'menu'
              ? 'header-component [data-mobile-toggle]'
              : null;

        if (!selector) return;
        const trigger = document.querySelector(selector);
        if (!trigger) return;

        event.preventDefault();
        trigger.click();
      };

      syncCartCount() {
        if (!this.headerBadge) return;
        const count = Number.parseInt(this.headerBadge.textContent.trim(), 10) || 0;
        this.querySelectorAll('[data-mobile-nav-cart-count]').forEach((badge) => {
          badge.textContent = count;
          badge.hidden = count === 0;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
